<template>
  <div class="mb-4">
    <!-- <b-button variant="primary" v-print="ServicesInvoice">
      Print Servies Invoice
    </b-button> -->

    <b-button variant="primary" v-print="PaymentInvoice" class="mx-2">
      Print سند صرف
    </b-button>
    <b-button variant="primary" v-print="CatchInvoice" class="mx-2">
      Print سند قبض
    </b-button>
    <b-button variant="primary" v-print="Report" class="mx-2">
      Print Report
    </b-button>
    <b-button variant="primary" v-print="outsideReceipt">
      Print وصل قبض
    </b-button>
    <!-- <ServicesInvoice /> -->

    <PaymentInvoice />
    <CatchInvoice /><Report />
    <OutsideReceipt />
  </div>
</template>
<script>
import {
  BCard,
  BLink,
  BFormGroup,
  BFormCheckbox,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
// import ServicesInvoice from "@components/printables/ServicesInvoice.vue";
const ServicesInvoice = () =>
  import("@/components/printables/ServicesInvoice.vue");

const PaymentInvoice = () =>
  import("@/components/printables/PaymentInvoice.vue");
const CatchInvoice = () => import("@/components/printables/CatchInvoice.vue");
const Report = () => import("@/components/printables/Report.vue");
const OutsideReceipt = () =>
  import("@/components/printables/OutsideReceipt.vue");

export default {
  components: {
    BCard,
    BLink,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    ServicesInvoice,

    PaymentInvoice,
    CatchInvoice,
    Report,
    OutsideReceipt,
  },
  data() {
    return {
      ServicesInvoice: {
        id: "ServicesInvoice",
      },
      IVF: {
        id: "IVF",
      },
      PaymentInvoice: {
        id: "PaymentInvoice",
      },
      CatchInvoice: {
        id: "CatchInvoice",
      },
      Report: {
        id: "Report",
      },
      outsideReceipt: {
        id: "outsideReceipt",
      },
    };
  },
};
</script>

<!-- <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.print-content {
  display: none;
}

/* Show the print content when printing */
@media print {
  .print-content {
    display: block;
  }
  button {
    display: none; /* Hide the button when printing */
  }
}
</style> -->
